import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

export const applySections: Record<
    CreditCardProductCategory,
    Array<{ heading: string; text: string }>
> = {
    [CreditCardProductCategory.BalanceTransfer]: [
        {
            heading: 'Compare the best deals',
            text: 'Find the longest 0% periods and lowest fees available to you. Keep an eye out for TotallySure offers which come with pre-approval and guarantees.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Before applying we’ll run a quick check to show you your chances of being accepted. This won’t affect your credit score.',
        },

        {
            heading: 'Get accepted',
            text: 'Once you’ve been approved and you received your new card, transfer your existing balances within the promotional period.',
        },

        {
            heading: 'Make a plan',
            text: 'Set up a Direct Debit to clear your balance before the 0% period ends, and avoid using the card for spending.',
        },
    ],

    [CreditCardProductCategory.Cashback]: [
        {
            heading: 'Compare your offers',
            text: 'Shop around and look at what different providers are offering. Some cards will give you flat rates on everything, while others might pay more for specific purchases like groceries or fuel.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Using an eligibility checker will help you find out your chances of being accepted before you apply. TotallySure offers come with pre-approval and guarantees.',
        },

        {
            heading: 'Get accepted',
            text: 'Once you’ve been approved, you’ll need to wait a few days before you receive your card. Then you can start earning cashback on your spending.',
        },

        {
            heading: 'Clear the balance monthly',
            text: 'It’s a good idea to set up a Direct Debit to automatically pay off your balance in full every month. If you don’t, it’s likely that the interest you pay will cost you more than the cashback you earn.',
        },
    ],

    [CreditCardProductCategory.Combined]: [
        {
            heading: 'Work out what you need',
            text: 'Have a think about what the priority – do you need more time to clear the debt, or to pay off new purchases, and pick the card which best suits your needs.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Know your chances of being accepted before you apply, and keep an eye out for TotallySure offers which come with pre-approval and guarantees.',
        },

        {
            heading: 'Get accepted',
            text: 'Once approved, you’ll receive your card within a few days. Remember that you’ll usually need to do the balance transfer within a few months of opening the account.',
        },

        {
            heading: 'Make a repayment plan',
            text: 'Work out how much you need to pay each month to clear the transferred balance and any purchases before the 0% periods end. It’s usually best to set up a Direct Debit so you don’t miss any payments.',
        },
    ],

    [CreditCardProductCategory.PoorCredit]: [
        {
            heading: 'Compare cards',
            text: 'Find the best credit building cards available to you. Some might come with TotallySure, which means pre-approval and guarantees.',
        },

        {
            heading: 'Check your eligibility',
            text: 'We’ll run a quick check to show you your chances of being accepted without affecting your credit score.',
        },

        {
            heading: 'Get accepted',
            text: 'Once approved, you’ll receive your credit card in the post within 7-10 days to start, and then you can start rebuilding your credit file.',
        },

        {
            heading: 'Use it responsibly',
            text: 'Make small purchases and pay off your balance in full each month to start improving your credit score, and showing lenders you’re a good borrower.',
        },
    ],

    [CreditCardProductCategory.Purchase]: [
        {
            heading: 'Compare the best deals',
            text: 'Shop around and look at what each provider is offering. Just remember that the best cards with the longest 0% periods will usually only be available to people with the best credit scores.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Before applying we’ll run a quick check to show you your chances of being accepted, and the good news is that this won’t affect your credit score. Keep an eye out for TotallySure offers which come with pre-approval and guarantees.',
        },

        {
            heading: 'Get accepted',
            text: 'Once you’ve been approved, you’ll need to wait for a few days before you receive your new card. And once you do, you can start making purchases with 0% interest during the initial promotional period.',
        },

        {
            heading: 'Make a plan',
            text: 'It’s usually a good idea to set up a Direct Debit to clear your balance in full every month. You should also try to not overspend, because you’ll start paying interest on any debt you carry past the 0% period.',
        },
    ],

    [CreditCardProductCategory.Rewards]: [
        {
            heading: 'Compare your options',
            text: 'A supermarket branded card might be best if you do a big weekly shop, whereas cashback cards can give you more flexibility.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Find out your chances of being accepted before you apply. Keep an eye out for TotallySure offers which come with pre-approval and guarantees.',
        },

        {
            heading: 'Get accepted',
            text: 'Once you’ve been approved, you’ll need to wait for a few days before you receive your new card. Then you can start earning rewards on your spending.',
        },

        {
            heading: 'Use it wisely',
            text: 'Set up a Direct Debit to clear your balance in full every month. If you don’t pay off what you owe, you could start paying interest.',
        },
    ],

    [CreditCardProductCategory.Travel]: [
        {
            heading: 'Compare your options',
            text: 'Shop around, and look at the foreign transaction fees and charges on cash withdrawals. Some might also have annual fees, so work out if you travel enough to make it worthwhile.',
        },

        {
            heading: 'Check your eligibility',
            text: 'Use an eligibility checker to find out your chances of being accepted before you apply. Look out for TotallySure offers which come with pre-approval and guarantees.',
        },

        {
            heading: 'Get accepted',
            text: 'You’ll usually receive your card within a few days. Let your card provider know if you’re travelling, or they might block your card when you use it abroad.',
        },

        {
            heading: 'Pay in local currency',
            text: 'Remember that when asked if you want to pay in pounds or the local currency, you should almost always choose local as it could result in a better rate.',
        },
    ],

    // TODO: Add apply sections for other categories when the data is ready
    [CreditCardProductCategory.BestCards]: [],
}
